module.exports = __webpack_public_path__ + "ae9ae8331a142bc9ce60901d10a41fc6.svg";